import { getAccountId } from '@/shared/auth/selectors';
import type { WiwState } from '@/store';

import { createSelector } from '@reduxjs/toolkit';

export const getUsers = createSelector(
  [(state: WiwState) => state.data.user.items, getAccountId],
  (users, accountId) => {
    return users.filter(user => user.account_id === accountId && !user.is_deleted);
  },
);
